import { commitMutation, graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';

import environment from '../RelayEnv';

const mutation = graphql`
  mutation ReplyMutation($input: ReplyInput!) {
    reply(input: $input) {
      replyEdge {
        node {
          id
          text
          ...Reply_reply
          message {
            id
          }
        }
      }
      clientMutationId
    }
  }
`;

const commit = function(viewerID, actionId, text, onSuccess, onFailure) {
  const variables = {
    input: {
      actionId,
      text,
    },
  };

  return commitMutation(environment, {
    mutation,
    variables,
    updater: store => {
      const payload = store.getRootField('reply');
      const replyEdge = payload.getLinkedRecord('replyEdge');
      if (!replyEdge) {
        console.log('No replyEdge in payload');
        return;
      }

      const node = replyEdge.getLinkedRecord('node');
      if (!node) {
        console.log('No node in replyEdge');
        return;
      }

      const message = node.getLinkedRecord('message');
      if (!message) {
        console.log('No message in reply node');
        return;
      }

      const messageID = message.getValue('id');
      console.log('Message ID:', messageID);
      const messageProxy = store.get(messageID);
      if (messageProxy == null) {
        console.log('Message not found in store:', messageID);
        return;
      }

      // Try to get the connection - it might not exist if no replies have been loaded yet
      // Try without arguments first (for backward pagination with 'last')
      let conn = ConnectionHandler.getConnection(
        messageProxy,
        'Replies_replies',
        { last: 10 }, // Default count from Replies component
      );

      // If that doesn't work, try without arguments
      if (conn == null) {
        conn = ConnectionHandler.getConnection(messageProxy, 'Replies_replies');
      }

      if (conn == null) {
        console.log(
          'Connection Replies_replies not found on message - replies may not be loaded yet',
        );
        // Connection doesn't exist yet - the subscription will handle it when it arrives
        return;
      }

      console.log('Adding reply to connection');
      const newEdge = ConnectionHandler.createEdge(
        store,
        conn,
        node,
        'ReplyEdge',
      );
      ConnectionHandler.insertEdgeAfter(conn, newEdge);
    },
    onCompleted: onSuccess,
    onError: onFailure,
  });
};

export default { commit };
